import type { BulkOperationStatus } from "../types.ts";

const terminalBulkStatuses = new Set<BulkOperationStatus>(["success", "failure", "partialFailure", "skipped"]);

/** Allowlist rather than "not planned/inProgress", so a status added to the BFF later isn't treated as done by default. */
export function isTerminalBulkStatus(status: BulkOperationStatus | undefined) {
    return status !== undefined && terminalBulkStatuses.has(status);
}
